import { QueryOptions, FetchPolicy } from 'apollo-client';
import { IdeaQueryVariables } from './__generated__/IdeaQuery';
import * as query from './query.gql';

export const ideaQuery = (
  variables: IdeaQueryVariables,
  fetchPolicy: FetchPolicy = 'network-only'
): QueryOptions<IdeaQueryVariables> => ({
  query,
  variables,
  fetchPolicy,
});
